import './PublicPuzzleNotFound.css';


const PublicPuzzleNotFound = (props) => {

  return (<div>Oops! No Puzzle Found!</div>)
};

export default PublicPuzzleNotFound;